import React, { createElement } from "react";
import SideBar from "./SideBar";

const RefereedJournal = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar refereedJournal={true} />
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Refereed Journal </div>
          <hr />
          <div className="textAlign">
            
          <p className="my-3 text-bold">2026</p>
          <p className="pb-2">
              Elaheh Sadeh, Abdolreza Farhadian, Atanu K Metya, Abolfazl Mohammadi, Nastaran Sayarri  &nbsp;
              <a href="https://doi.org/10.1016/j.fuel.2026.140134" target={"_blank"} className="remove-underline bold-600">
              Glucoside-derived alkylated and sulfonated surfactants for environmentally friendly hydrate-based CO2 capture
              </a>
              &nbsp; Fuel (2027),428, 140134.
            </p>           
          <p className="pb-2">
              Ramkhelavan Kanaujiya, Atanu K. Metya, Rajnish Kumar, Tarak K. Patra  &nbsp;
              <a href="https://pubs.rsc.org/en/content/articlelanding/2026/cp/d5cp04275e" target={"_blank"} className="remove-underline bold-600">
              Nanobubble size controls gas hydrate nucleation in supercooled water
              </a>
              &nbsp; Phys. Chem. Chem. Phys. (2026), 28, 13469-13476.
            </p> 
          <p className="pb-2">
              Rashi Srivastava, Shreyans K Jain, Atanu K Metya, Jose V Parambil &nbsp;
              <a href="https://scijournals.onlinelibrary.wiley.com/doi/full/10.1002/jctb.70110" target={"_blank"} className="remove-underline bold-600">
              Ultrasonic‐assisted phytochemical extraction using hydrophobic natural deep eutectic solvents: from solvation energy prediction to process optimization
              </a>
              &nbsp; J. Chem. Technol. Biotechnol. (2026), 101: 517–526.
            </p>
            <p className="pb-2">
              Ingrid de Almeida Ribeiro, Yuqing Qiu, Esteban D Gadea, Atanu K Metya, Valeria Molinero*  &nbsp;
              <a href="https://pubs.rsc.org/en/content/articlelanding/2026/cp/d5cp04275e" target={"_blank"} className="remove-underline bold-600">
              Immersion Freezing at Topographic Active Sites: Dual-Barrier Prediction of Ice Nucleation Temperatures
              </a>
              &nbsp;  J. Am. Chem. Soc. (2026), 148, 3291−3304.
            </p>

          <p className="my-3 text-bold">2025</p>
          <p className="pb-2">
              Karnati Ganesh Reddy, Sunandini Swain, Aryan Aryan, Atanu K Metya* &nbsp;
              <a href="https://doi.org/10.1007/s44345-025-00038-4" target={"_blank"} className="remove-underline bold-600">
              Molecular insights into curcumin’s Anti-Alzheimer’s potential through Amyloid-β and Tau interactions
              </a>
              &nbsp; Discov. Mol. (2025), 2, 30 (Invited article).
            </p>
          <p className="pb-2">
              Sunandini Swain, Atanu K Metya &nbsp;
              <a href="https://pubs.acs.org/doi/full/10.1021/acschemneuro.5c00456" target={"_blank"} className="remove-underline bold-600">
              Computational Insights into Dopamine-Mediated Conformational Transitions of Aβ Aggregates in Alzheimer’s Disease
              </a>
              &nbsp; ACS Chem. Neurosci., (2025), 16, 3774-3789.
             </p>
          <p className="pb-2">
              Sunandini Swain, Anik Sen*, Atanu K Metya* &nbsp;
              <a href="https://advanced.onlinelibrary.wiley.com/doi/full/10.1002/adts.202500715" target={"_blank"} className="remove-underline bold-600">
              Computational Design and Assessment of Bi‐Heterocyclic Donepezil Derivatives as Enhanced Acetylcholinesterase Inhibitors
              </a>
              &nbsp; Adv. Theory Simul. (2025), 8, e00715.
              </p> 
          <p className="pb-2">
              Karnati Ganesh Reddy, Atanu K Metya* &nbsp;
              <a href="https://doi.org/10.1016/j.ijbiomac.2025.145833" target={"_blank"} className="remove-underline bold-600">
              Design and identification of novel drug candidates targeting RET: Accurate drug affinity estimation using funnel metadynamics
              </a>
              &nbsp; Int. J. Biol. Macromol. (2025), 320, 145833.
            </p>
          <p className="pb-2">
              Ramkhelavan Kanaujiya, Atanu K Metya*, Nilesh Choudhary, Rajnish Kumar, Tarak K Patra* &nbsp;
              <a href="https://doi.org/10.1039/D5CP01574J" target={"_blank"} className="remove-underline bold-600">
              Molecular dynamics insights into tetrahydrofuran-assisted formation of CH4, CO2, and H2 gas hydrates
              </a>
              &nbsp;Phys. Chem. Chem. Phys. (2025), 27, 13991-13999.
            </p>
          <p className="pb-2">
              Sunandini Swain, Atanu K Metya  &nbsp;
              <a href="https://pubs.acs.org/doi/full/10.1021/acs.jcim.5c00106" target={"_blank"} className="remove-underline bold-600">
              Exploring Metformin’s Therapeutic Potential for Alzheimer’s Disease: An In-Silico Perspective Using Well-Tempered Funnel Metadynamics
              </a>
              &nbsp; J. Chem. Inf. Model. (2025), 65, 4163-4172.
            </p>
          <p className="pb-2">
              Parth Kanani, K. Ganesh Reddy, Md Adil, Atanu K Metya*  &nbsp;
              <a href="https://doi.org/10.1016/j.molliq.2025.127118" target={"_blank"} className="remove-underline bold-600">
              Impact of Antifreeze and Promoter on Clathrate Hydrate Nucleation and Growth
              </a>
              &nbsp; J. Mol. Liq. (2025), 424, 127118.
            </p>
            <p className="pb-2">
              Sunandini Swain, Anik Sen*, and Atanu K Metya*  &nbsp;
              <a href="https://doi.org/10.1080/07391102.2024.2306200" target={"_blank"} className="remove-underline bold-600">
              Rational Design for Novel Heterocyclic based Donepezil Analogs for Alzheimer’s Disease: An in Silico Approach
              </a>
              &nbsp; J. Biomol. Struct. Dyn. (2025), 43, 4985-4996.
            </p>

          <p className="my-3 text-bold">2024</p>
          <p className="pb-2">
              Sunandini Swain, Anik Sen*, Atanu K Metya*  &nbsp;
              <a href="https://doi.org/10.1016/j.molliq.2024.125500" target={"_blank"} className="remove-underline bold-600">
              Investigating the multifunctionality of fluorinated donepezil derivatives for Alzheimer’s disease
              </a>
              &nbsp; J. Mol. Liq. (2024), 409, 125500.
            </p>
            <p className="pb-2">
              Abir Ghosh, Sunandini Swain, Atanu K Metya* &nbsp;
              <a href="https://doi.org/10.1039/d4cp02993c" target={"_blank"} className="remove-underline bold-600">
              Electric-field-induced structure and dynamics of an ethanol–water mixture in hydrophobic–hydrophilic nanochannels
              </a>
              &nbsp;Phys. Chem. Chem. Phys. (2024), 26, 26834-26841.
            </p>
          <p className="pb-2">
              Rashi Srivastava, Nivedita Bhardwaj, Shreyans K. Jain, Atanu K. Metya*, and Jose V. Parambil*  &nbsp;
              <a href="https://doi.org/10.1016/j.molliq.2024.125314" target={"_blank"} className="remove-underline bold-600">
              Unveiling the potential of acetic acid-based hydrophobic natural deep eutectic solvents for phytochemical extraction
              </a>
              &nbsp; J. Mol. Liq. (2024), 408, 125314.
            </p>
          <p className="pb-2">
              Atanu K. Metya* and Chandan Das  &nbsp;
              <a href="https://doi.org/10.1021/acs.langmuir.3c03184" target={"_blank"} className="remove-underline bold-600">
              Electrolyte under Molybdenum Disulfide Surfaces: Molecular Insights on Structure and Dynamics of Water
              </a>
              &nbsp; Langmuir (2024), 40, 3540-3548.
            </p>
            <p className="pb-2">
            Vikas K Sinha, Atanu K Metya, and Chandan K Das &nbsp;
              <a href="https://doi.org/10.1016/j.fluid.2023.113985" target={"_blank"} className="remove-underline bold-600">
              Estimation of solid-liquid coexistence curve for coarse-grained water models through reliable free energy method
              </a>
              &nbsp;Fluid Phase Equilib. (2024), 577,113985.
            </p>

            <p className="my-3 text-bold">2023</p>
            <p className="pb-2">
              Rima Biswas, Atanu K. Metya, Kindenew M. Abebe, Sara A. Gedf and Birtukan T. Melese  &nbsp;
              <a href="https://doi.org/10.1007/s00894-023-05643-z" target={"_blank"} className="remove-underline bold-600">
              Carbon dioxide solubility in choline chloride-based deep eutectic solvents under diverse conditions
              </a>
              &nbsp;J. Mol. Model. (2023), 29, 236.
            </p>

            <p className="my-3 text-bold">2022</p>
            <p className="pb-2">
              Atanu K. Metya&nbsp;
              <a href="https://doi.org/10.1021/acs.jpcb.2c04998" target={"_blank"} className="remove-underline bold-600">
              Insight into the Structure and Dynamics of Ethanol-Water Binary Mixture 
              Confined in Nanochannel by Mica and Graphene
              </a>
              &nbsp;J. Phys. Chem. B (2022), 126, 7385-7392.
            </p>
            <p className="pb-1">
              Niwesh Ojha, Atanu K.Metya and Sushant Kumar&nbsp;
              <a href="https://doi.org/10.1016/j.apsusc.2021.152315" target={"_blank"} className="remove-underline bold-600">
                Influence of plasmonic metals (Ag, Cu) on overall CO2
                photoreduction activity of β-Ga2O3
              </a>
              &nbsp;Appl. Surf. Sci. (2022), 580, 152315.
            </p>

            <p className="my-3 text-bold">2021</p>
            <p className="pb-2">
              Manish Maurya, Atanu K. Metya, Jayant K. Singh, and Shinji
              Saito&nbsp;
              <a href="https://doi.org/10.1063/5.0046817" target={"_blank"} className="remove-underline bold-600">
                Effects of interfaces on structure and dynamics of water
                droplets on a graphene surface: A molecular dynamics study
              </a>
              &nbsp;J. Chem. Phys. (2021), 154,164704.
            </p>
            <p className="pb-2">
              Atanu K. Metya and Valeria Molinero &nbsp;
              <a href="https://doi.org/10.1021/jacs.0c12012" target={"_blank"} className="remove-underline bold-600">
                Is Ice Nucleation by Organic Crystals Nonclassical? An
                Assessment of the Monolayer Hypothesis of Ice Nucleation
              </a>
              &nbsp;J. Am. Chem. Soc. (2021), 143, 12, 4607-4624.
            </p>

            <p className="my-3 text-bold">2020</p>
            <p className="pb-2">
              Pavithra M. Naullage#, Atanu K. Metya#, and Valeria Molinero (# equal contribution)&nbsp;
              <a href="https://doi.org/10.1063/5.0021631" target={"_blank"} className="remove-underline bold-600">
                Computationally Efficient Approach for the Identification of
                Ice-Binding Surfaces and How They Bind Ice
              </a>
              &nbsp;J. Chem. Phys. (2020), 153, 174106.
            </p>

            <p className="my-3 text-bold">2019</p>
            <p className="pb-2">
              Prerna, Rohit Goswami, Atanu K. Metya, S. V. Shevkunov, and Jayant
              K. Singh&nbsp;
              <a href="https://doi.org/10.1080/00268976.2019.1657599" target={"_blank"} className="remove-underline bold-600">
                Study of Ice Nucleation on Silver Iodide Surface with Defects
              </a>
              &nbsp;Mol. Phys. (2019), 117, 3651-3663 .
            </p>
            <p className="pb-2">
              Atanu K. Metya and Jayant K Singh&nbsp;
              <a href="https://doi.org/10.1080/08927022.2018.1513649" target={"_blank"} className="remove-underline bold-600">
                Ice Adhesion Mechanism on Lubricant-Impregnated Surfaces using
                Molecular Dynamics Simulations
              </a>
              &nbsp;Mol. Simul. (2019), 45, 394–402.
            </p>

            <p className="my-3 text-bold">2018</p>
            <p className="pb-2">
              Atanu K. Metya and Jayant K Singh&nbsp;
              <a href="https://doi.org/10.1021/acs.jpcc.8b05989" target={"_blank"} className="remove-underline bold-600">
                Ice Nucleation on a Graphite Surface in the Presence of
                Nanoparticles
              </a>
              &nbsp;J. Phys. Chem. C (2018), 122, 19056−19066.
            </p>
            <p className="pb-2">
              Atanu K. Metya and Jayant K Singh&nbsp;
              <a href="https://doi.org/10.1021/acs.jpcc.7b12495" target={"_blank"} className="remove-underline bold-600">
                Nucleation of Aqueous Sal Solutions on Solid Surfaces
              </a>
              &nbsp;J. Phys. Chem. C (2018), 122, 8277–8287.
            </p>

            <p className="my-3 text-bold">2016</p>
            <p className="pb-2">
              Atanu K. Metya, Jayant K Singh, and Florian Muller-Plathe&nbsp;
              <a href="https://doi.org/10.1039/C6CP04382H" target={"_blank"} className="remove-underline bold-600">
                Ice nucleation on nanotextured surfaces: Influence of surface
                fraction, pillar height and wetting states
              </a>
              &nbsp;Phys. Chem. Chem. Phys. (2016), 18, 26796-26806.
            </p>

            <p className="my-3 text-bold">2015</p>
            <p className="pb-2">
              Arnab Bose, Atanu K. Metya and Jayant K. Singh&nbsp;
              <a href="https://doi.org/10.1039/C5CP03778F" target={"_blank"} className="remove-underline bold-600">
                Surface Effect on Electromelting Behavior of Nanoconfined Water
              </a>
              &nbsp;Phys. Chem. Chem. Phys. (2015), 17, 23147–23154.
            </p>

            <p className="my-3 text-bold">2014</p>
            <p className="pb-2">
              Utsav Kumar, Atanu K. Metya, N. Ramakrishnan, and Jayant K.
              Singh&nbsp;
              <a href="https://iopscience.iop.org/article/10.1149/2.1171409jes" target={"_blank"} className="remove-underline bold-600">
                A Study of Transport Properties and Stress Analysis using
                Atomistic and Macro Simulations for Lithium-Ion Batteries
              </a>
              &nbsp;J. Electrochem. Soc. (2014), 165 A1453–A1460.
            </p>
            <p className="pb-2">
              Atanu K. Metya, Sandip Khan and Jayant K Singh&nbsp;
              <a href="https://doi.org/10.1021/jp4096437" target={"_blank"} className="remove-underline bold-600">
                Wetting Transition of Ethanol-Water Droplet on Smooth and
                Textured Surfaces
              </a>
              &nbsp;J. Phys. Chem. C (2014), 118, 4113–4121.
            </p>
            <p className="my-3 text-bold">2012</p>
            <p className="pb-2">
              Atanu K. Metya, Abhiram Hens, Jayant K. Singh&nbsp;
              <a href="https://doi.org/10.1016/j.fluid.2011.08.026" target={"_blank"} className="remove-underline bold-600">
                Molecular dynamics study of VLE and transport properties of
                Sodium and Lithium-based on EAM potentials
              </a>
              &nbsp;Fluid Phase Equilibria (2012), 313, 16–24.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefereedJournal;
